<template>
  <div class="app-breadcrumb">
    <v-breadcrumbs :items="crumbs" dark>
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: 'BaseBreadCrumb',
  computed: {
    crumbs() {
      const crumbs = [];
      this.$route.matched.map(e => {
        if (e.meta.breadCrumb) {
          const params = this.$route.params;
          const mappingParams = Object.keys(params).reduce((acc, param) => {
            acc[`:${param}`] = params[param];
            return acc;
          }, {});
          const mappingParamsArr = Object.keys(mappingParams);
          const path = e.path.replace(new RegExp(mappingParamsArr.join('|'), 'ig'), matched => mappingParams[matched]);

          crumbs.push({
            text: this.$t(e.meta.breadCrumb),
            to: { path: mappingParamsArr.length ? path : e.path },
            activeClass: ''
          });
        }
      });
      if (crumbs.length > 0) {
        if (this.$route.name === 'StudentAssignmentScoreQuiz') {
          crumbs.forEach(data => {
            data.activeClass = 'v-breadcrumbs__item--disabled';
          });
        } else {
          crumbs[crumbs.length - 1].activeClass = 'v-breadcrumbs__item--disabled';
        }
      }
      return crumbs;
    }
  }
};
</script>

<style lang="scss">
.app-breadcrumb {
  > ul {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  a {
    color: #fff !important;
    font-family: Montserrat;
    font-weight: bold;

    &.v-breadcrumbs__item--disabled {
      opacity: 0.6;
    }
  }
}
</style>
